import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Computer from './components/computer/Computer';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <Computer />
  </React.StrictMode>
);

reportWebVitals();
